<template>
    <div class="tab-menu-wrap">
        <ul class="tab-menu">
            <li class="tab-menu__item active"><a href="">My wellness(үндсэн) </a></li>
            <li class="tab-menu__item"><a href="">wellness upgrade(нарийвчилсан)</a></li>
            <li class="tab-menu__item"><a href="">wellness ceo(дээд зэрэглэлийн)</a></li>
            <li class="tab-menu__item"><a href="">Нэмэлт шинжилгээ</a></li>
        </ul>
    </div>
    <div class="tab-menu-con">
        <div class="tab-content active">
            <div class="lang">
                <div class="info">
                    <h3 class="bullet01">My wellness(үндсэн)</h3>
                    <p class="depth">20-иос дээш насныханд зориулсан, тэднийг насанд хүрэгчдийн өвчнөөс сэргийлэх болон
                        өвчнийг анхан шатанд нь илрүүлэх багц шинжилгээ.</p>
                    <div class="table mt20">
                        <table>
                            <caption>My wellness (EXAMINATION ITEMS)</caption>
                            <colgroup>
                                <col style="width: 10%">
                                <col style="width: 10%">
                                <col style="width: 10%">
                                <col style="width: auto">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" colspan="4">Шинжилгээ</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th sope="rowgroup" rowspan="12" class="br"
                                        style="border-right: 1px solid #d9d9d9;">Үндсэн</th>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Ерөнхий шинжилгээ</span>
                                    </th>
                                    <td class="left">Биеийн хэмжилт(өндөр, жин), биеийн ерөнхий үзүүлэлт(таргалалт),
                                        цусны даралт</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Сонсголын шинжилгээ</span>
                                    </th>
                                    <td class="left">Стандарт сонсголын шинжилгээ</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Харааны шинжилгээ</span>
                                    </th>
                                    <td class="left">Хараа шалгах, нүдний даралт үзэх, нүдний уг дурандах</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Зүрх судасны системийн үйл ажиллагаа</span>
                                    </th>
                                    <td class="left">Уушигны үйл ажиллагаа, цээжний рентген зураг, зүрхний бичлэг</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Шээс болон өтгөний шинжилгээ</span>
                                    </th>
                                    <td class="left">Шээсний хурдас бичил харуурын шинжилгээ, өтгөнд далд цус алдалт
                                        илрүүлэх сорил</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Цусны шинжилгээ</span>
                                    </th>
                                    <td class="left">
                                        Цусны ерөнхий шинжилгээ (RBC, WBC, Hb, Hct, RDW, Platelet, MCV, MCH),<br>
                                        цусны бүлэг (ABO бүлэг, Rh бүлэг),<br>
                                        D витамины шинжилгээ (Vitamine D),<br>
                                        Чихрийн шижингийн шинжилгээ (glucose, HbA1C),<br>
                                        Элэгний үйл ажиллагааны шинжилгээ (T. Protein, Albumin, AST, ALT, ALP, r-GTP,
                                        TB, DB),<br>
                                        Элэгний вирусын шинжилгээ (A/B/C вирус),<br>
                                        Титэм судасны эмгэг (Homocystein, CRP, CK, poprotein A1, Apoprotein B),<br>
                                        Өөх тос, холестрины шинжилгээ (T.chole, HDL, LDL, TG, LDH),<br>
                                        Бамбай булчирхайн үйл ажиллагааны шинжилгээ (T3, Free T4, TSH),<br>
                                        Бөөрний үйл ажиллагааны шинжилгээ (BUN, Creatinine),<br>
                                        электролитын шинжилгээ (Ca, K, Na, Cl, P, T.CO2),<br>
                                        Тулайн сорил (Uric acid),<br>
                                        Дархлааны сийвэнгийн шинжилгээ (ревматизм:RF,тэмбүү:VDRL),<br>
                                        ДОХ-ын шинжилгээ (Anti-HIV),<br>
                                        Нойр булчирхайн шинжилгээ(Amylase),<br>
                                        Хавдрын маркер[элэг (AFP), ходоод/бүдүүн гэдэс (CEA), нойр булчирхай (CA19-9),
                                        эпителийн эсийн хавдар(SCC), өндгөвчний хорт хавдар (CA 125, эмэгтэй), түрүү
                                        булчирхайн хорт хавдар (PSA, эрэгтэй)]
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Ходоодны хорт хавдрын шинжилгээ</span>
                                    </th>
                                    <td class="left">Ходоодны дуран</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Эхо</span>
                                    </th>
                                    <td class="left">Хэвлийн эхо</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>Бусад</span>
                                    </th>
                                    <td class="left">Биологийн нас, Биеийн тамир, хөдөлгөөний зөвлөгөө</td>
                                </tr>
                                <tr>
                                    <th scope="row" rowspan="2" class="br">
                                        <span>Эмэгтэйчүүдийн шинжилгээ</span>
                                    </th>
                                    <td>30-аас доош нас</td>
                                    <td class="left">Умайн хүзүүний хорт хавдрын эсийн шинжилгээ, Улаанууд өвчний
                                        шинжилгээ</td>
                                </tr>
                                <tr>
                                    <td>30-аас дээш нас</td>
                                    <td class="left">Умайн хүзүүний хорт хавдрын эсийн шинжилгээ, Хөхний рентген зураг
                                        авахуулах</td>
                                </tr>
                                <tr>
                                    <th sope="rowgroup" rowspan="6" class="br">Үндсэн нэмэлт</th>
                                </tr>
                                <tr>
                                    <td class="bl left" colspan="3">Үндсэн багц + Ясны сийрэгжилтийн оношилгоо+
                                        Судасны хатуурлын оношилгоо+Стрессын тест + A-D төрлийн шинжилгээнээс нэгийг
                                        сонгох</td>
                                </tr>
                                <tr>
                                    <th scope="row" class="bl left" colspan="3">
                                        <span>A. Бага тунтай уушигны CT</span>
                                    </th>
                                </tr>
                                <tr>
                                    <th scope="row" class="bl left" colspan="3">
                                        <span>B. Бамбай булчирхайн эхо</span>
                                    </th>
                                </tr>
                                <tr>
                                    <th scope="row" class="bl left" colspan="3">
                                        <span>C. Бага тунтай уушигны CT+ Бамбай булчирхайн эхо</span>
                                    </th>
                                </tr>
                                <tr>
                                    <th scope="row" class="bl left" colspan="3">
                                        <span>D. Эмэгтэйчүүдийн эхо&amp;Хүний папиллома вирус(HPV)</span>
                                    </th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p class="font-sub mt20">
                        * 30-аас доош насны эмэгтэй гэр бүлд хөхний хорт хавдраар өвчилж байсан хүн байвал хөхний хорт
                        хавдрыг оношлох рентген зураг авахуулахыг зөвлөж байна.
                    </p>
                </div>
            </div>
        </div>
        <div class="tab-content">
            <div class="lang">
                <div class="info">
                    <h3 class="bullet01">wellness upgrade(нарийвчилсан)</h3>
                    <p class="depth">Солонгос хүмүүст зонхилон тохиолддог хорт хавдар болон зүрх судасны өвчнийг анхан
                        шатанд нь илрүүлэх нарийвчилсан багц шинжилгээ.(Үндсэн болон үндсэн нэмэлт багцыг сонгосны дараа
                        Set нэмэх боломжтой.)</p>
                    <div class="table mt20">
                        <table>
                            <caption>wellness upgrade (EXAMINATION ITEMS)</caption>
                            <colgroup>
                                <col style="width: 10%">
                                <col style="width: auto">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" colspan="2">Шинжилгээ</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th rowspan="2" scope="row" class="br">Зүрхний Set</th>
                                    <td class="left">(Үндсэн) Зүрхний эхо, Гүрээний артерийн эхо</td>
                                </tr>
                                <tr>
                                    <td class="left">(Нарийвчилсан)Зүрхний эхо, Гүрээний артерийн эхо, Зүрхний 3DCT
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">Тархи, судасны Set</th>
                                    <td class="left">Тархины MRI + MR Angio, Гүрээний артерийн эхо</td>
                                </tr>
                                <tr>
                                    <th scope="row">Хоол боловсруулах эрхтний хорт хавдрын Set</th>
                                    <td class="left">Хэвлийн &amp; Аарцагны CT, бүдүүн гэдэсний дуран, Гүн
                                        тайвшруулгатай дуран (унтуулгатай)</td>
                                </tr>
                                <tr>
                                    <th scope="row">Эмэгтэйчүүдийн хорт хавдрын Set</th>
                                    <td class="left">Хөхний эхо, эмэгтэйчүүдийн эхо, Хүний папиллома вирус (HPV),
                                        эмэгтэй гормон(LH/FSH/ES/AMH)</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p class="depth bullet03 mt20">Солонгос хүмүүст зонхилон тохиолддог хорт хавдар болон зүрх судасны
                        өвчнийг анхан
                        шатанд нь илрүүлэх нарийвчилсан багц шинжилгээ.(Үндсэн болон үндсэн нэмэлт багцыг сонгосны дараа
                        Set нэмэх боломжтой.)</p>
                    <div class="table mt20">
                        <table>
                            <caption>Шинжилгээ</caption>
                            <colgroup>
                                <col style="width: 10%">
                                <col style="width: auto">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" colspan="2">Шинжилгээ</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th rowspan="2" scope="rowgroup">Гол хoрт хавдар</th>
                                    <td class="left">
                                        Эрэгтэй: Үндсэн нэмэлт C (бага тунтай уушигны CT+бамбай булчирхайн эхо) +
                                        хэвлий&amp;аарцагны CT, бүдүүн гэдэсний дуран, гүн тайвшруулгатай дуран
                                        (унтуулгатай)<br><br>
                                        Эмэгтэй: Үндсэн нэмэлт C (бага тунтай уушигны CT+бамбай булчирхайн эхо) +
                                        хэвлий&amp;аарцагны CT, бүдүүн гэдэсний дуран, гүн тайвшруулгатай дуран
                                        (унтуулгатай), хөхний эхо, эмэгтэйчүүдийн эхо, хүний папиллома вирус(HPV)
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-content">
            <div class="lang">
                <div class="info">
                    <h3 class="bullet01">wellness ceo(дээд зэрэглэлийн)</h3>
                    <div class="table">
                        <table>
                            <caption>WELLNESS CEO(Шинжилгээ)</caption>
                            <colgroup>
                                <col style="width: 10%">
                                <col style="width: auto">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" colspan="2">Шинжилгээ</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="rowgroup">Нил ягаан</th>
                                    <td class="left">
                                        Эрэгтэй: Үндсэн нэмэлт C (бага тунтай уушигны CT+бамбай булчирхайн эхо) +
                                        хэвлий&amp;аарцагны CT, бүдүүн гэдэсний дуран, гүн тайвшруулгатай
                                        дуран(унтуулгатай), гүрээний артерийн эхо, зүрхний 3DCT, тархины MRI+MR
                                        Angio<br><br>
                                        Эмэгтэй: Үндсэн нэмэлт C (бага тунтай уушигны CT+бамбай булчирхайн эхо) +
                                        хэвлий&amp;аарцагны CT, бүдүүн гэдэсний дуран, гүн тайвшруулгатай (унтуулгатай),
                                        хөхний эхо, эмэгтэйчүүдийн эхо, хүний папиллома вирус(HPV), үрээний артерийн
                                        эхо, зүрхний 3DCT, тархины MRI+MR Angio
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">Алтан</th>
                                    <td class="left">
                                        Эрэгтэй: WELLNESS CEO Нил ягаан+Зүрхний эхо, PET CT + VIP өрөөнд 1 өдөр
                                        хонох<br><br>
                                        Эмэгтэй: WELLNESS CEO Нил ягаан+Зүрхний эхо, PET CT + VIP өрөөнд 1 өдөр хонох
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-content">
            <div class="lang">
                <div class="info">
                    <h3 class="bullet01">Нэмэлт шинжилгээ</h3>
                    <div class="table">
                        <table>
                            <caption>Нэмэлт шинжилгээ (Шинжилгээ)</caption>
                            <colgroup>
                                <col style="width: 10%">
                                <col style="width: auto">
                                <col style="width: 20%">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" colspan="3">Шинжилгээ</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th rowspan="4" scope="row" class="br">Дуран</th>
                                    <td colspan="2" class="left">Бүдүүн гэдэсний дуран</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">Ходоодны дуран гүн тайвшруулгатай (унтуулгатай)</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">Бүдүүн гэдэсний дуран гүн тайвшруулгатай
                                        (унтуулгатай)</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">Ходоод болон бүдүүн гэдэсний дуран гүн тайвшруулгатай
                                        (унтуулгатай)</td>
                                </tr>
                                <tr>
                                    <th rowspan="13" scope="row" class="br">Компьютер томограф</th>
                                    <td class="left">Хэвлийн CT</td>
                                    <td class="left">Тодосгогчтой</td>
                                </tr>
                                <tr>
                                    <td class="left">Хэвлийн &amp; аарцагны CT</td>
                                    <td class="left">Тодосгогчтой</td>
                                </tr>
                                <tr>
                                    <td class="left">Элэгний CT</td>
                                    <td class="left">Тодосгогчтой</td>
                                </tr>
                                <tr>
                                    <td class="left">Нойр булчирхайн CT</td>
                                    <td class="left">Тодосгогчтой</td>
                                </tr>
                                <tr>
                                    <td class="left">Бөөрний CT</td>
                                    <td class="left">Тодосгогчтой</td>
                                </tr>
                                <tr>
                                    <td class="left">Тархины CT</td>
                                    <td class="left">Тодосгогчтой</td>
                                </tr>
                                <tr>
                                    <td class="left">Зүрхний(титэм судас_3D)CT</td>
                                    <td class="left">Тодосгогчтой</td>
                                </tr>
                                <tr>
                                    <td class="left" colspan="2">зүрх судасны шохойжилт(Ca) CT</td>
                                </tr>
                                <tr>
                                    <td class="left" colspan="2">Сээр нурууны(C-Spine) CT</td>
                                </tr>
                                <tr>
                                    <td class="left" colspan="2">Бүсэлхий нурууны(L-Spine) CT</td>
                                </tr>
                                <tr>
                                    <td class="left" colspan="2">Бага тунтай уушигны CT</td>
                                </tr>
                                <tr>
                                    <td class="left">Уушигны(нарийвчилсан) CT</td>
                                    <td class="left">Тодосгогчтой</td>
                                </tr>
                                <tr>
                                    <td class="left" colspan="2">Хэвлийн таргалалт(FAT) CT</td>
                                </tr>
                                <tr>
                                    <th rowspan="7" scope="row" class="br">MRI/MRA </th>
                                    <td class="left">Тархины MRI</td>
                                    <td class="left">Тодосгогчтой</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">Тархины судасны MRA</td>
                                </tr>
                                <tr>
                                    <td class="left">Тархины MRI&amp;MR ANGIO</td>
                                    <td class="left">Тодосгогчтой</td>
                                </tr>
                                <tr>
                                    <td class="left">Бүтэн биеийн MRI</td>
                                    <td class="left">Тодосгогчтой</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">Сээр нурууны (C-Spine) MRI</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">Бүсэлхий нурууны (L-Spine) MRI</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">Бүсэлхий, сээр нурууны MRI</td>
                                </tr>
                                <tr>
                                    <th scope="row" class="br">PET-CT</th>
                                    <td class="left">Тархи&amp;Бүтэн биеийн PET-CT</td>
                                    <td class="left">Тодосгогчтой</td>
                                </tr>
                                <tr>
                                    <th rowspan="6" scope="row" class="br">Эхо</th>
                                    <td colspan="2" class="left">Зүрхний эхо</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">Гүрээний артерын эхо</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">Бамбай булчирхайн эхо</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">Түрүү булчирхайн эхо</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">Хөхний эхо</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">Эмэгтэйчүүдийн эхо</td>
                                </tr>
                                <tr>
                                    <th rowspan="9" scope="row" class="br">Бусад шинжилгээ</th>
                                    <td colspan="2" class="left">Дижитал(3D) хөхний зураг</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">хүний папиллома вирус</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">гормон(эмэгтэй)</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">гормон(эрэгтэй)</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">ясны сийрэгжилт</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">стресс</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">NK дархлааны эсийн шинжилгээ</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">гэдэсний микробиомын шинжилгээ</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">харшлын шинжилгээ(цусны бүлэг_хооллолт)</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>
<script>
export default {

}
</script>